import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import { useAuth } from '../hooks'
import { store, history } from '../store'
import { createRoutes } from './routes'
import { ga, handleRouteUpdate } from './helpers'

const Routes = () => {
  const auth = useAuth()
  return (
    <Provider store={store} >
      <Router onUpdate={() => handleRouteUpdate(store, ga)} history={history}>
        {createRoutes(auth)}
      </Router>
    </Provider>
  )
}

export default Routes
